export default "__VITE_ASSET__05e41218__"